export default __webpack_public_path__ + "static/media/likedicon.b7df64cf.svg";